module.exports = __webpack_public_path__ + "static/media/expertise-deliver.5eea1a39.svg";